import React, { useRef, useState } from 'react';

export default function ContactForm({ content }) {
  const [status, setStatus] = useState('idle');
  const pending = useRef(false);
  const submitting = status === 'submitting';

  const submit = async event => {
    event.preventDefault();
    if (pending.current) return;
    const form = event.currentTarget;
    pending.current = true;
    setStatus('submitting');

    try {
      const response = await fetch(content.endpoint, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      });
      if (!response.ok) throw new Error('Contact form submission failed.');
      form.reset();
      setStatus('success');
    } catch {
      setStatus('error');
    } finally {
      pending.current = false;
    }
  };

  return (
    <form className="contact-form" aria-label={content.formName} aria-busy={submitting}
      action={content.endpoint} method="POST" onSubmit={submit}>
      <input name="subject" type="hidden" value={content.subject} />
      <input name="form_name" type="hidden" value={content.formName} />
      <div className="contact-form__row">
        <label className="contact-form__field">
          <span>{content.fields.name}</span>
          <input className="contact-form__input" name="name" type="text" autoComplete="name" required />
        </label>
        <label className="contact-form__field">
          <span>{content.fields.email}</span>
          <input className="contact-form__input" name="email" type="email" autoComplete="email" required />
        </label>
      </div>
      <label className="contact-form__field">
        <span>{content.fields.organization} <small className="contact-form__optional">{content.optionalLabel}</small></span>
        <input className="contact-form__input" name="organization" type="text" autoComplete="organization" />
      </label>
      <label className="contact-form__field">
        <span>{content.fields.message}</span>
        <textarea className="contact-form__textarea" name="message" rows="3" required />
      </label>
      <button className="contact-form__submit" type="submit" disabled={submitting}>
        {submitting ? content.submittingLabel : content.submitLabel}
      </button>
      <p className="contact-form__status" role={status === 'error' ? 'alert' : 'status'} aria-atomic="true">
        {status === 'success' ? content.successMessage : status === 'error' ? content.errorMessage : ''}
      </p>
    </form>
  );
}
